import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { invalidateModelProviders } from "./fetchModelProviders";
const useSetDefaultModelProvider = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const { mutateAsync } = useMutation({
    mutationFn: (provider) => AIConfiguredModelProviders.setDefaultProvider(provider),
    onSuccess: (_result, provider) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_MANAGEMENT.MODEL_PROVIDER_DEFAULT_SET, {
        app_section: "ai-management-model-providers",
        event_details: { provider }
      });
      UserNotification.success("Default model provider changed.");
      invalidateModelProviders(queryClient);
    },
    onError: (error) => UserNotification.error(`Changing the default model provider failed: ${error.message}`)
  });
  return { setDefault: mutateAsync };
};
export default useSetDefaultModelProvider;
